import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';
import styles from './ProductBox.module.scss';
import anime from 'animejs';

export default class ProductBox extends Component {
  static propTypes = {
    product: PropTypes.object,
    isFadeInActive: PropTypes.func.isRequired
  };

  static defaultProps = {
    product: []
  };

  constructor(props) {
    super(props);
    const { product } = props;
    this.state = {
      product: product,
      productNext: product,
      fadeInActive: false,
      activeSlideIndex: props.activeSlideIndex,
      changeBackground: false
    };

    this.animationDuration = 750;
    this.columnEasing = 'easeInOutCubic';
    this.animation = {
      Title: {
        targets: '#productWrapper #productName',
        easing: 'linear'
      },
      Column1: {
        targets: '#productWrapper #productImage'
      },
      Column2: {
        targets: '#productWrapper #productDescription1'
      }
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      productNext: props.product,
      activeSlideIndex: props.activeSlideIndex
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.activeSlideIndex !== prevState.activeSlideIndex) {
      if (this.state.productNext !== prevState.product) {
        this.animate(true, '0', '50');
      }
    }
  }

  render() {
    const {
      product: { title, description, image }
    } = this.state;

    return (
      <div className={`${styles.Wrapper}`} id="productWrapper">
        <div className={styles.ImageBox}>
          <div className={styles.ImageWrapper}>
            <img
              src={OptimizeImagesService.adjustImageSize(image)}
              alt="Product"
              id="productImage"
              className={styles.Image}
            />
          </div>
        </div>
        <div className={styles.ContentBox}>
          <h2 className={styles.ProductName} id="productName">
            {title}
          </h2>
          <div className={styles.DescriptionBox}>
            <div
              className={styles.ProductDescriptionBox}
              id="productDescription1"
            >
              <div
                className={styles.ProductDescriptionParagraph}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  animate(isFadeOut, opacity, boxesTransition) {
    anime({
      ...this.animation.Title,
      duration: this.animationDuration,
      opacity: opacity
    });

    const basicTimeline = anime.timeline({
      duration: this.animationDuration / 3,
      easing: this.columnEasing,
      complete: anim => {
        if (isFadeOut) {
          this.setState({
            product: this.state.productNext,
            fadeInActive: true
          });
          this.animate(false, '1', '0');
        }
        if (!isFadeOut) {
          this.setState({
            fadeInActive: false
          });
        }
        this.FadeInActive(this.state.fadeInActive);
      }
    });
    basicTimeline
      .add({
        ...this.animation.Column1,
        translateY: boxesTransition,
        opacity: opacity
      })
      .add({
        ...this.animation.Column2,
        translateY: boxesTransition,
        opacity: opacity
      })
      .add({
        ...this.animation.Column3,
        translateY: boxesTransition,
        opacity: opacity
      });
  }

  FadeInActive(bool) {
    this.props.isFadeInActive(bool);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Products/Components/ProductBox/ProductBox.js